module.exports = __webpack_public_path__ + "wpicons.ebd5edf58f2b20aa15c2.svg";


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/rooster/admin/src/assets/fonts/wpicons.svg
// module id = ../../../../../src/assets/fonts/wpicons.svg
// module chunks = 2